import { gql } from 'apollo-angular';

export default gql`
  mutation saveField($field: FieldInput!) {
    saveField(field: $field) {
      __typename
      ... on Field {
        uri
        name
        tenantUri
        fieldTypeUri
        version
        createdOn
        createdByUri
        updatedOn
        updatedByUri
        propertyValues {
          fieldUri
          fieldTypePropertyUri
          value
        }
      }
      ... on ValidationResult {
        hasViolations
        violations {
          source
          providedValue
          description
          localisationResourceId
        }
      }
    }
  }
`;
